export enum ZendeskRequestType {
    Ticket = 'ticket',
    Request = 'request'
  }


// WEBPACK FOOTER //
// ./src/model/types/zendesk-request-type.ts